import * as Yup from 'yup'

export default Yup.object({
  name: Yup.string().required('入力必須です。').max(50, '50文字以下で入力してください。'),
})
